module.exports = __webpack_public_path__ + "img/头像.02769bf9.png";